import { Types } from '@grandvisionhq/graphql';

// CartState used as variable from enum
const CartState = Types.CheckoutState;

export { CartState };
//# sourceMappingURL=cart-state.js.map
